import { Factory } from './strategy/Factory';

export default Factory.lazyLoadImage;



// WEBPACK FOOTER //
// ./src/index.js